import { CheckboxOptionType } from 'antd';

export const redemptionLimitsOptions = {
  single: {
    label: 'Single redemption',
    value: false,
  },
  multiple: {
    label: 'Multiple redemption',
    value: true,
  },
};

export const availDaysOptions = {
  everyDay: {
    label: 'Every Day',
    value: 'everyDay',
  },
  specificDays: {
    label: 'Every specific day of the week',
    value: 'specificDays',
  },
};

export const weekDaysOptionsShort: CheckboxOptionType<'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun'>[] = [
  { label: 'Mon', value: 'mon' },
  { label: 'Tue', value: 'tue' },
  { label: 'Wed', value: 'wed' },
  { label: 'Thu', value: 'thu' },
  { label: 'Fri', value: 'fri' },
  { label: 'Sat', value: 'sat' },
  { label: 'Sun', value: 'sun' },
];

export const weekDaysOptionsFull: CheckboxOptionType<'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun'>[] = [
  { label: 'Monday', value: 'mon' },
  { label: 'Tuesday', value: 'tue' },
  { label: 'Wednesday', value: 'wed' },
  { label: 'Thursday', value: 'thu' },
  { label: 'Friday', value: 'fri' },
  { label: 'Saturday', value: 'sat' },
  { label: 'Sunday', value: 'sun' },
];
